export default "{\n    \"facilityLabel\": \"Instalación\"\n}\n"